export default function (nga, admin) {
  var subscriptionReport = admin.getEntity("SubscriptionsReport");
  subscriptionReport
    .listView()
    .title(
      '<h4>Subscriptions Report <i class="fa fa-angle-right" aria-hidden="true"></i> List</h4>'
    )
    .batchActions([])
    .fields([
      nga
        .field("customer_username")
        .isDetailLink(false)
        .label("Login"),
      nga
        .field("login_data.mac_address")
        .isDetailLink(false)
        .label("Mac Address") ,
      nga
        .field("combo.name")
        .label("Combo name"),
      nga
        .field("start_date", "date")
        .label("Start date"),
      nga
        .field("end_date", "date")
        .label("End date"),
      nga.field("status", "string")
        .template(function (entry, values) {
          try{
            var currentDate = new Date().getTime();
            var startDate = new Date(entry.values.start_date).getTime();
            var endDate = new Date(entry.values.end_date).getTime();
            if(entry.values.end_date == null || entry.values.end_date == ""){
              return "<span style='color: gold'>InActive</span>";
            }
            if(isNaN(endDate)){
              return "<span style='color: gold'>InActive</span>";
            }
            if (startDate <= currentDate && endDate >= currentDate) {
              return "<span style='color: green'>Active</span>";
            } else {
              return "<span style='color: red'>Expired</span>";
            }
          } catch(e){
            return "<span style='color: gold'>Inactive</span>";
          }
        })
        .label("Status"),
    ])
    .filters([
      nga
        .field("q")
        .template(
          '<div class="input-group"><input type="text" ng-model="value" placeholder="Search" class="form-control"></input><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>'
        )
        .label("")
        .pinned(true),
      nga.field('status', 'choice')
        .attributes({ placeholder: 'Select Status' })
        .label('Status')
        .choices(
          [
            { value: 'Active', label: 'Active' },
            { value: 'Expired', label: 'Expired' },
            { value: 'Inactive', label: 'Inactive' }
          ]
        ),
    ])
    .exportFields([subscriptionReport.listView().fields()]);
  return subscriptionReport;
}



// WEBPACK FOOTER //
// ./js/subscriptionReport/config.js